import { CommonService } from 'src/app/services/common.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  ActivatedRoute,
} from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoginService } from './login.service';
@Injectable({
  providedIn: 'root'
})
export class OAuth2Guard implements CanActivate {
  ON_PREMISES = environment.ON_PREMISES;
  ON_PREMISES_CAS = environment.ON_PREMISES_CAS;
  ON_CLOUD = environment.ON_CLOUD;
  PROFILE = environment.ENV_ACTIVE_PROFILE;
  hasIdtoken: any;
  hasAccessToken: any;
  accessToken: any;
  constructor(
    private oauthService: OAuthService,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private loginService: LoginService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot):
    |Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
      // OIDC enviroment (OKTA,o Auth0, etc....)
      if (this.PROFILE === this.ON_PREMISES)
      {
        // onPremises enviroment
        if (sessionStorage.getItem('nonce'))
        {
          return true;
        }
        else
        {
          this.oauthService.initLoginFlow();
          return false;
        }
      }
        // Congito environment
      else if (this.PROFILE === this.ON_CLOUD)
      {
        if (sessionStorage.getItem('isLogin') !== 'yes')
        {
          this.loginService.redirectToLogin();
        }
        else
        {
          return true;
        }
      }
      // CAS environment
      else if(this.PROFILE === this.ON_PREMISES_CAS)
      {
        if (sessionStorage.getItem('isLogin') !== 'yes')
        {
          this.loginService.CAS_LoginPage();
        }
        else
        {
          return true;
        }
      }
    }
}
